/** returns a throttled function that never runs more often than
 * every `delay` milliseconds.
 * The returned function also has a nice `.finish()` method.
 */
var throttle = function (func, delay, skipFirst) {
    var timeout;
    var throttled = 0;
    var _args;
    var _this;
    var throttledFn = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        _args = args;
        _this = this;
        if (!throttled) {
            skipFirst ? throttled++ : func.apply(_this, _args);
            timeout = setTimeout(throttledFn.finish, delay); // Go home TypeScript, you're drunk!
        }
        throttled++;
    };
    throttledFn.finish = function (cancel) {
        timeout && clearTimeout(timeout);
        !cancel && throttled > 1 && func.apply(_this, _args);
        throttled = 0;
    };
    return throttledFn;
};
/** Sugar to produce a dynamic debounced function that accepts its contents/behavior at call time.
 *
 * Usage:
 *
 *      const myThrottler = throttle.d(500);
 *      myThrottler(() => { alert('Hello world'); });
 *      myThrottler(() => { alert('I mean: Howdy world!'); });
 *      myThrottler((name) => { alert('Wazzap ' + name); }, 'world');
 */
throttle.d = function (delay, skipFirst) {
    return throttle(function (fn) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        fn.apply(this, args);
    }, delay, skipFirst);
};

module.exports = throttle;
